import { render, staticRenderFns } from "./ReviewAndSign.vue?vue&type=template&id=f19d21b0&"
import script from "./ReviewAndSign.vue?vue&type=script&lang=js&"
export * from "./ReviewAndSign.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAndSign.vue?vue&type=style&index=0&id=f19d21b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports